<template>
  <v-card
    :flat="!$vuetify.breakpoint.mdAndUp"
    :color="!$vuetify.breakpoint.mdAndUp ? 'grey lighten-3' : ''"
    :outlined="$vuetify.breakpoint.mdAndUp"
    :class="$vuetify.breakpoint.mdAndUp ? 'rounded-lg mt-4' : ''"
    id="card-container"
  >
    <v-card-title
      :class="$vuetify.breakpoint.mdAndUp ? 'px-4' : ''"
      class="pa-0 my-4"
    >
      <h3 class="checkout-h3">{{ $t("cart.locationMap") }}</h3>
    </v-card-title>
    <v-card-text class="grey--text text-xs-center">
      <panZoom
        v-if="coordinates && coordinates.length"
        id="panz"
        @init="onInit"
        :style="`overflow: hidden; outline: none !important; cursor: move; max-height: ${
          !$vuetify.breakpoint.mdAndUp ? '350px' : '450px'
        }; ${!$vuetify.breakpoint.mdAndUp ? 'max-width: 350px;' : ''}`"
        :options="{
          minZoom: !$vuetify.breakpoint.mdAndUp ? 0.2 : 0.48,
          maxZoom: !$vuetify.breakpoint.mdAndUp ? 4 : 4,
          zoomSpeed: $vuetify.breakpoint.mdAndUp ? 0.195 : 0.195,
          pinchSpeed: 1,
          touchEnabled: true,
          zoomDoubleClickSpeed: 1,
          bounds: !$vuetify.breakpoint.mdAndUp ? true : true,
          boundsPadding: 0.1,
        }"
      >
        <svg
          id="svgId"
          class="noselect"
          width="770px"
          height="700px"
          style="-webkit-tap-highlight-color: rgba(0, 0, 0, 0)"
        >
          <g class="noselect" style="cursor: default">
            <image
              class="noselect"
              :xlink:href="mapUrl"
              width="770px"
              height="653"
              x="0"
              y="0"
            ></image>
            <polygon
              v-for="(coordinate, i) in coordinates"
              :key="i"
              :id="coordinate.productId"
              slot="activator"
              :style="
                sectors.find((s) => s.codigo === hoverShape)
                  ? 'cursor: pointer'
                  : ''
              "
              @mousedown="checkIfDrag"
              @mouseup="selectSector(coordinate.productId)"
              @mouseenter="handleMouse(coordinate.productId)"
              @mouseleave="handleMouse(null)"
              class="noselect"
              sector-id="961069"
              :opacity="hoverShape === coordinate.productId ? '1' : '0'"
              fill="rgba(255,255,0,0.5)"
              :points="coordinate.shape"
            ></polygon>
          </g>
        </svg>
      </panZoom>
      <div v-else>
        <v-img
          max-width="700"
          width="100%"
          ref="imgEvent"
          class="map__img"
          v-if="mapUrl && !$vuetify.breakpoint.mdAndUp"
          :src="mapUrl"
          alt="Evento"
        />
        <MapDialog
          v-else-if="mapUrl && $vuetify.breakpoint.mdAndUp"
          :mapUrl="mapUrl"
        />
        <div v-else class="text-xs-center">{{ $t("general.unavailable") }}</div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import MapDialog from "./MapDialog.vue";

export default {
  components: { MapDialog },
  props: ["mapUrl"],
  data() {
    return {
      hover: false,
      windowWidth: 0,
      stageSize: {
        width: 600,
        height: 600,
      },
      seats: [],
      panInst: null,
      panId: null,
      pzx: null,
      pzy: null,
      mapSize: 475,
      selectedSeat: null,
      image: null,
      timeoutDrag: null,
      isDrag: false,
    };
  },
  computed: {
    ...mapGetters([
      "hoverShape",
      "sectors",
      "noSectorProducts",
      "separateProducts",
      "eventDetails",
      "eventId",
    ]),
    coordinates() {
      let array = [];
      if (this.sectors && this.sectors.length) {
        this.sectors.forEach((p) => {
          if (p.mapa_coordenadas)
            p.mapa_coordenadas.forEach((shape) => {
              let findedShape = array.find((obj) => obj.shape == shape);
              if (!findedShape)
                array.push({ shape: shape, productId: p.codigo });
            });
        });
      }
      if (this.separateProducts) {
        this.separateProducts.forEach((p) => {
          if (p.mapa_coordenadas)
            p.mapa_coordenadas.forEach((shape) => {
              let findedShape = array.find((obj) => obj.shape == shape);
              if (!findedShape)
                array.push({ shape: shape, productId: p.codigo_produto });
            });
        });
      }
      return array;
    },
  },
  methods: {
    checkIfDrag() {
      this.timeoutDrag = setTimeout(() => {
        this.isDrag = true;
      }, 150);
    },
    selectSector(index) {
      if (!this.isDrag) {
        let isSector = null;
        if (this.$vuetify.breakpoint.xs && index)
          isSector = this.sectors.find((s) => s.codigo === Number(index));
        else isSector = this.sectors.find((s) => s.codigo === this.hoverShape);
        if (isSector) {
          let params = {
            event_id: this.eventId,
            sector_id: Number(index),
          };
          if (this.couponDetails && this.couponDetails.isCupomValid)
            params.coupon = this.couponDetails.cupomData.campaign_coupon;
          this.$store.dispatch("getSeatsSector", params);
          this.$store.commit("SET_HOVER_SHAPE", null);
          this.$store.commit("SET_SHOW_SEAT_MAP", true);
          this.$store.commit("SET_SELECTED_SECTOR", isSector);
        }
      }
      clearTimeout(this.timeoutDrag);
      this.isDrag = false;
    },
    handleMouse(value) {
      this.$store.commit("SET_HOVER_SHAPE", value);
    },
    onInit: function (panzoomInstance, id) {
      this.pzx = document.getElementById("panz").offsetWidth;
      this.pzy = document.getElementById("panz").offsetHeight;
      this.panInst = panzoomInstance;
      this.panId = id;

      if (this.$vuetify.breakpoint.mdAndUp) {
        panzoomInstance.moveTo(-10, 30);
        panzoomInstance.zoomAbs(0, 0, 0.5);
      } else {
        panzoomInstance.moveTo(0, 10);
        panzoomInstance.zoomAbs(0, 0, 0.4);
      }

      this.mapIsReady = true;
    },
  },
};
</script>

<style>
.polygon:hover {
  background-color: red !important;
}
.polygons-area {
  position: absolute;
}
.noselect {
  -webkit-touch-callout: none !important; /* iOS Safari */
  -webkit-user-select: none !important; /* Safari */
  -khtml-user-select: none !important; /* Konqueror HTML */
  -moz-user-select: none !important; /* Old versions of Firefox */
  -ms-user-select: none !important; /* Internet Explorer/Edge */
  user-select: none !important; /* Non-prefixed version, currently                           supported by Chrome, Opera and Firefox */
}
</style>
